import React, { useState } from "react";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { ReferalCard } from "@/components/ReferalCard/ReferalCard";
import { Pagination } from "@/ui/Pagination/Pagination";
import { useReferalsStateStore } from "@/store/referalsStateStore";
import classNames from "classnames";
import { dataTrigger } from "@/analytics";
import { useReferalsDataContext } from "@/store/ReferalsProvider";
import ContainerLoader from "@/ui/ContainerLoader/ContainerLoader";
import cls from "./styles.module.scss";

export const CompletedReferals = () => {
  const { completedReferals, loadCompletedReferals } = useReferalsDataContext();
  const completedReferalsList = completedReferals.results;
  const referalsPerPage = completedReferals.limit;

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const isOpen = useReferalsStateStore((s) => s.isCompletedReferalsOpen);
  const setIsOpen = useReferalsStateStore((s) => s.setIsCompletedReferalsOpen);

  const changePage = async (newPage: number) => {
    setIsLoading(true);

    setCurrentPage(newPage);
    const offset = (newPage - 1) * referalsPerPage;
    await loadCompletedReferals(offset);

    setIsLoading(false);
  };

  if (!completedReferalsList || completedReferalsList.length === 0) return null;

  return (
    <FlexColumn gap={8}>
      <FlexRow
        justifyContent="space-between"
        className={cls.missedReferals}
        role="tab"
        {...dataTrigger("ref.referrals.completed")}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <FlexRow gap={10}>
          <Typography className={cls.missedReferalsTitle}>
            Завершённые рефералы
          </Typography>

          <div className={cls.refCount}>{completedReferals.count} чел.</div>
        </FlexRow>

        <div
          className={classNames(cls.toggleIcon, isOpen ? cls.open : undefined)}
        >
          ▾
        </div>
      </FlexRow>

      {isOpen && (
        <>
          {isLoading ? (
            <ContainerLoader />
          ) : (
            <FlexColumn gap={14}>
              {completedReferalsList.map((elem) => (
                <ReferalCard
                  key={elem.telegram_user?.telegram_id}
                  referal={elem}
                />
              ))}
            </FlexColumn>
          )}

          <Pagination
            currentPage={currentPage}
            onPageChange={changePage}
            list={completedReferals}
          />
        </>
      )}
    </FlexColumn>
  );
};
